/**
 * Created by fjywan on 16/5/19.
 */
import moment from 'moment';

let requestHandleFunc = function (request) {
    if (/\/Database\/coupon_component/.test(request.url)) {

    }
    return request;
};

export default requestHandleFunc;



/** WEBPACK FOOTER **
 ** ./examples/request.js
 **/